import Vue from 'vue'

export default {
  setUser: (state, value) => {
    state.user = value
  },
  updateUser: (state, userObject) => {
    Vue.set(state.user, userObject.key, userObject.value)
  },
  setIsAuthenticated: (state, value) => {
    state.isAuthenticated = value
  },
  setJwt: (state, value) => {
    state.jwt = value
  }
}
